import { useStage } from './useStage'

export default () => useStage('device-authentication')
